import showConfirmModal from 'components/ConfirmModal';
import React from 'react';
import ReportProblemIcon from 'assets/report_problem.svg?react';

const editShowDiscardConfirmModal = (onOk: () => void) => {
  showConfirmModal({
    icon: <ReportProblemIcon />,
    title: 'Discard changes to your record?',
    content: <>None of the changes to this record will be saved.</>,
    okText: 'Discard changes',
    okButtonProps: {
      style: {
        borderRadius: 4,
        background: 'var(--Green-green-60, #14803C)',
        padding: '10px 16px',
        color: '#FFF',
        fontSize: 14,
        fontWeight: 400,
        marginLeft: 8
      }
    },
    cancelText: 'Continue editing',
    onOk
  });
};
export default editShowDiscardConfirmModal;
